import { CheckCircleOutlined  , WarningOutlined} from "@ant-design/icons";
import { Row,Col,Button } from 'antd'
import React from 'react'
import { SUCCESS_STATUS } from "../../utility/Constants";

function CustomMessage(props) {


  return (
    <div>
        <Row style={{
                    marginTop: "2rem",
                    background: "#f2f2f2",
                    padding: "10px",
                    borderRadius: "10px",
                    color: "#8e8e8e"
                }}>
                    <Col span={3}>
                       
                        {
                            props.title.toUpperCase() == SUCCESS_STATUS
                             ?  
                             <CheckCircleOutlined style={{ fontSize: '2.5rem', transition: "right 5s ease-in-out" , color: 'rgb(37, 189, 103)' }} /> 
                             : <WarningOutlined style={{ fontSize: '2.5rem', transition: "right 5s ease-in-out" , color: 'rgb(242, 87, 40)' }} />
                        }
                        
                        
                        
                    </Col>
                    <Col span={15}>
                        <h3>{props.title}</h3>
                        <p>{props.subtitle}</p>
                    </Col>
                    <Col span={6}>
                        {
                            props.mode == "ADD" ? 
                                <>
                                    <Button type="primary" shape="round" onClick={() => props.action()}>Add More</Button>
                                </> : 
                                <>
                                    <Button type="text" style={{backgroundColor:'#1a8811',color:'white'}} onClick={() => props.onDrawerClose()}>OK</Button>
                                </>
                        }
                        
                        
                    </Col>
                </Row>
    </div>
  )
}

export default CustomMessage